
app.widgetController = app.widgetController || {};
app.widgetController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.widgetOffres();
        this.widgetServices();
        this.widgetPromotions();
        this.widgetArticles();
        this.sliderTestimonials();
        this.widgetEvenements();
        this.widgetContacter();
    },

    widgetOffres : function () {
        /***** PANELS *****/
        var widget = $('.widget_offres');
        var listeOffres = $('.liste_offres', widget);
        var offres = $('.offre', listeOffres);


        $('.vignette', offres).on('click', function () {
            var vignette = $(this);
            var offre = vignette.parent();
            var text = offre.find('.text');
            var content = text.find('.text-content');

            $('.vignette', offres).removeClass('active');
            $('.text', offres).removeClass('active');

            if (window.matchMedia("(min-width: 769px)").matches) {
                if (vignette.hasClass('active')) {
                    $('.text', offres).removeAttr('style');
                    listeOffres.removeAttr('style');
                } else {
                    vignette.addClass('active');
                    text.addClass('active');

                    $('.text', offres).height(content.outerHeight());
                    listeOffres.height(content.outerHeight() + 301);
                }
            } else {
                $('.text', offres).removeAttr('style');

                if (!vignette.hasClass('active')) {
                    vignette.addClass('active');
                    text.addClass('active');

                    text.height(content.outerHeight());
                }
            }
        });

        $( window ).resize(function() {
            $('.text', offres).removeAttr('style');
            listeOffres.removeAttr('style');
            $('.vignette', offres).removeClass('active');
            $('.text', offres).removeClass('active');
        });

        /***** SLIDER ******/
        if (window.matchMedia("(max-width: 768px)").matches) {
            $('.remboursements', widget).slick({
                dots: false,
                infinite: true,
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                slide: '.widget_offres .remboursement',
            });
        }

        $('.arrow-left', widget).on('click', function () {
            $(this).closest('.remboursements').slick('slickPrev');
        });

        $('.arrow-right', widget).on('click', function () {
            $(this).closest('.remboursements').slick('slickNext');
        });

        $('.widget_offres .offre .vignette').on('click', function (event) {
            event.preventDefault();

            var page = $(this).data('link'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            var top = Math.round($(page).offset().top - 100);

            $('html, body').animate({scrollTop: top}, speed); // Go

            return false;
        });
    },

    widgetPromotions : function () {
        var widget = $('.widget_promotions');
        $('.slider-promo', widget).slick({
            dots: true,
            infinite: true,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $('.arrow-left', widget),
            nextArrow: $('.arrow-right', widget),
            slide: '.widget_promotions .promotion',
            fade: true
        });

        $('.slider-images', widget).slick({
            dots: false,
            infinite: true,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            slide: '.widget_promotions img',
            fade: true,
            arrows: false
        });

        $('.slider-promo', widget).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slider-images', widget).slick('slickGoTo', nextSlide);
        });

        $('.slider-images', widget).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slider-promo', widget).slick('slickGoTo', nextSlide);
        });
    },

    widgetArticles : function () {
        var widget = $('.widget_articles');
        $('.slider-container', widget).slick({
            dots: false,
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $('.arrow-left', widget),
            nextArrow: $('.arrow-right', widget),
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },

    widgetEvenements : function () {
        var widget = $('.widget_evenements');
        $('.slider-container', widget).slick({
            dots: false,
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $('.arrow-left', widget),
            nextArrow: $('.arrow-right', widget),
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },

    setBtnPosition : function (blk, blkVideo) {
        var topBlkVideo = blkVideo.offset().top;
        var leftBlkVideo = blkVideo.offset().left;
        var wBlkVideo = blkVideo.width();
        var hBlkVideo = blkVideo.height();

        var windowWidth = $(window).width();
        var windowHeight = $(window).height();

        var margin = 80;
        var marginFixed = 40;

        if (window.matchMedia("(max-width: 1024px)").matches) {
            margin = 40;
        }
        if (window.matchMedia("(max-width: 768px)").matches) {
            margin = 20;
            marginFixed = 20;
        }

        if (($(document).scrollTop() > $('header').height()) || window.matchMedia("(max-width: 768px)").matches) {
            blk.attr('style', 'position: fixed; bottom: ' + marginFixed + 'px; right: ' + marginFixed + 'px;');
        } else {
            var blkRight = windowWidth - (leftBlkVideo + wBlkVideo - margin);
            var blkBottom = windowHeight - (topBlkVideo + hBlkVideo - margin);

            blk.attr('style', 'bottom: ' + blkBottom + 'px;right: ' + blkRight + 'px;');
        }
    },

    widgetContacter : function () {
        var self = this;
        var blk = $('#nous-contacter');
        var blkVideo = $('.header-video .content-text');

        if (blk.length && blkVideo.length) {
            self.setBtnPosition(blk, blkVideo);

            $( window ).resize(function() {
                self.setBtnPosition(blk, blkVideo);
            });

            $(document).scroll( function() {
                self.setBtnPosition(blk, blkVideo);
            });
        }


        var btn = $('> .btn', blk);
        var overflow = $('#nous-contacter-overflow');

        var boutons = $('.boutons', blk);
        var container = $('.container', boutons);

        btn.add(overflow).on('click', function () {
            var bouton = $('.bouton, .gb-zm-wrapper', boutons);
            var time = 0;

            if (btn.hasClass('active')) {
                boutons.delay(750).animate({
                    height: 0,
                    width: 0
                }, 0);

                $(bouton.get()).each(function() {
                    $(this).delay(time).animate({ opacity: 0 }, 150);
                    time += 100;
                });

                btn.removeClass('active');

                overflow.delay(300).animate({
                    opacity: 0
                }, 250);
                overflow.delay(550).animate({
                    width: 0,
                    height: 0
                }, 0);

            } else {
                boutons.attr('style', 'height: ' + container.outerHeight() + 'px; width: ' + container.outerWidth() + 'px;');

                $(bouton.get().reverse()).each(function() {
                    $(this).delay(time).animate({ opacity: 1 }, 150);
                    time += 100;
                });

                btn.addClass('active');
                overflow.attr('style', 'width: 100%; height: 100%; opacity: 1;');
            }
        });
    },

    widgetServices : function () {
        objectFitImages();
    },

    sliderTestimonials : function () {
        var block = $('.home-testimonials');

        $('.slider-container', block).slick({
            dots: false,
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $('.arrow-left', block),
            nextArrow: $('.arrow-right', block),
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },
};

$(document).ready(function(){
    app.widgetController.defaultAction.init();
});
